import React from 'react';
import { TypedMemo } from '../../../common/types';
import { SMLButton } from '../../../common/views/SMLButton/SMLButton';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the song files; each part uses its own slice of it */
import styles from '../../../smartLinks/catalog/song/SongFiles.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SongFactRowProps {
  label: string;
  /** The state line. Leave it out when `children` shows the state (the master player). */
  text?: string;
  /** True for a state that stops some assets: a missing or failed file. */
  isProblem?: boolean;
  /** The button that opens the song page in Catalog. Only a missing or failed part has one. */
  action?: { label: string; onClick: () => void };
  children?: React.ReactNode;
  testId?: string;
}

/** One fact of the song in Releases and the Studio: a label, the state, and the button to fix it. */
const SongFactRowComponent: React.FC<SongFactRowProps> = (props) => {
  const { label, text, isProblem = false, action, children, testId } = props;
  return (
    <div className="d-flex flex-column gap-1" data-testid={testId}>
      <span className={styles.mono}>{label}</span>
      {children}
      {(text !== undefined || action !== undefined) && (
        <div className="d-flex flex-wrap align-items-center gap-2">
          {text !== undefined && <span className={isProblem ? styles.error : styles.strong}>{text}</span>}
          {action !== undefined && (
            <SMLButton outline omitCap size="sm" onClick={action.onClick}>
              {action.label}
            </SMLButton>
          )}
        </div>
      )}
    </div>
  );
};

export const SongFactRow = TypedMemo(SongFactRowComponent);
